import { createSlice } from '@reduxjs/toolkit'
import { setProfileSettings } from '@wellesley/host-remote/api/actions'
import type { NestedUserSettings } from '../../helpers/nestedUserSettings'

export type ProfileSettingsState = {
  data: NestedUserSettings | null
}

const initialState: ProfileSettingsState = {
  data: null,
}

export const profileSettingsSlice = createSlice({
  name: 'profileSettings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setProfileSettings, (state, { payload }) => {
      state.data = payload
    })
  },
  selectors: {
    selectProfileSettings: (state) => state.data,
  },
})
